import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function IconPlaceholder({
  children,
  backgroundColor = token.gray25,
  iconColor = token.gray400a,
  ...props
}) {
  return /* @__PURE__ */ jsx(Placeholder, {
    $backgroundColor: backgroundColor,
    $iconColor: iconColor,
    ...props,
    children
  });
}
const Placeholder = styled.div.withConfig({
  displayName: "Placeholder",
  componentId: "sc-qax8fp-0"
})(["display:flex;justify-content:center;align-items:center;min-height:100px;background:", ";color:", ";svg{width:48px;height:48px;}"], (props) => props.$backgroundColor, (props) => props.$iconColor);
export {
  IconPlaceholder
};
//# sourceMappingURL=IconPlaceholder.js.map
